import ArrowBack from '@mui/icons-material/ArrowBack'
import Timer from '@mui/icons-material/Timer'
import dayjs from 'dayjs'
import { useMemo } from 'react'
import { CHeading1 } from 'src/components/coreUIMimicComponent'
import { PRACTICE_TIMER_TYPES } from 'src/consumer/constants'
import { overlayPageStates } from '../TimerComponent/TimerController'
import { BackButton, BeginPracticeButton } from '../TimerComponent/styledComponents'
import {
  TimerStartOverlayTimerDetailItem,
  TimerStartOverlayTimerDetailsContainer,
} from './styledComponents'

export default function TimerStartOverlay({
  timerData,
  beginTimer,
  backToPreviousPage,
  countDown,
  overlayPageState,
}) {
  const durationToShow = useMemo(() => {
    switch (timerData?.durationType) {
      case PRACTICE_TIMER_TYPES.unlimited:
        return 'Unlimited'
      case PRACTICE_TIMER_TYPES.fixed:
        return dayjs.utc(timerData?.duration).format('mm:ss')
      case PRACTICE_TIMER_TYPES.range:
        return dayjs.utc(timerData?.minDuration).format('mm:ss')
      default:
        return dayjs.utc(timerData?.duration).format('mm:ss')
    }
  }, [])

  const intervalsLength = (timerData?.intervals || [])?.length

  return (
    <>
      {overlayPageState === overlayPageStates.landing && (
        <>
          <div className="d-flex justify-content-start w-100">
            <BackButton onClick={backToPreviousPage}>
              <ArrowBack /> <span>Back</span>
            </BackButton>
          </div>
          <div className="d-flex justify-content-center align-items-center flex-column gap-1">
            <span className="small-heading">Practice Timer</span>
            <CHeading1 style={{ fontSize: 'calc(1.875rem + 1.5vw)' }}>{timerData?.title}</CHeading1>
            <TimerStartOverlayTimerDetailsContainer>
              <TimerStartOverlayTimerDetailItem>
                <Timer />
                <span className="item-name">Duration: </span>
                <span className="item-value">{durationToShow}</span>
              </TimerStartOverlayTimerDetailItem>

              {timerData?.durationType === PRACTICE_TIMER_TYPES?.range && (
                <TimerStartOverlayTimerDetailItem>
                  <Timer />
                  <span className="item-name">Max Duration: </span>
                  <span className="item-value">
                    {dayjs.utc(timerData?.maxDuration).format('mm:ss')}
                  </span>
                </TimerStartOverlayTimerDetailItem>
              )}

              {intervalsLength > 0 && (
                <TimerStartOverlayTimerDetailItem>
                  <span className="item-name">Intervals: </span>
                  <span className="item-value">{intervalsLength}</span>
                </TimerStartOverlayTimerDetailItem>
              )}
            </TimerStartOverlayTimerDetailsContainer>
          </div>
          <BeginPracticeButton onClick={beginTimer}>Begin</BeginPracticeButton>
        </>
      )}

      {overlayPageState === overlayPageStates.countDown && (
        <>
          <div></div>
          <div className="d-flex justify-content-center align-items-center gap-1">
            <span className="countdown-timer">{3 - countDown + 1}</span>
          </div>
          <div></div>
        </>
      )}
    </>
  )
}
